<template>
  <div>
    <b-card
      no-body
      class="p-2"
    >
      <b-row>
        <b-col cols="12">
          <h4 class="mb-2">
            Gestão de Contribuições
          </h4>
          <p class="text-muted">
            Configure as regras, períodos e valores que compõem o sistema de contribuições.
          </p>
        </b-col>
      </b-row>

      <b-row class="match-height mt-2">
        <!-- Tipos de Faixa -->
        <b-col
          v-if="verificarPermissao('ROLE_TIPO_FAIXA_CONSULTAR')"
          xl="4"
          md="6"
        >
          <b-card
            class="text-center cursor-pointer shadow-none border hover-shadow-lg transition-all"
            @click="$router.push({ name: 'mensalidades-tipo-faixa' })"
          >
            <div class="avatar avatar-xl bg-light-primary mb-2 mx-auto">
              <div class="avatar-content">
                <feather-icon
                  icon="ListIcon"
                  size="24"
                />
              </div>
            </div>
            <h5 class="font-weight-bolder">
              Tipos de Faixa
            </h5>
            <p class="card-text">
              Defina as categorias e estruturas das faixas de contribuição.
            </p>
            <b-button
              variant="outline-primary"
              class="mt-1"
              block
              :to="{ name: 'mensalidades-tipo-faixa' }"
            >
              Acessar
            </b-button>
          </b-card>
        </b-col>

        <!-- Períodos de Vigência -->
        <b-col
          v-if="verificarPermissao('ROLE_PERIODO_VIGENCIA_CONSULTAR')"
          xl="4"
          md="6"
        >
          <b-card
            class="text-center cursor-pointer shadow-none border hover-shadow-lg transition-all"
            @click="$router.push({ name: 'mensalidades-vigencia' })"
          >
            <div class="avatar avatar-xl bg-light-success mb-2 mx-auto">
              <div class="avatar-content">
                <feather-icon
                  icon="ClockIcon"
                  size="24"
                />
              </div>
            </div>
            <h5 class="font-weight-bolder">
              Períodos de Vigência
            </h5>
            <p class="card-text">
              Gerencie os intervalos de tempo em que os valores são válidos.
            </p>
            <b-button
              variant="outline-success"
              class="mt-1"
              block
              :to="{ name: 'mensalidades-vigencia' }"
            >
              Acessar
            </b-button>
          </b-card>
        </b-col>

        <!-- Matriz de Valores -->
        <b-col
          v-if="verificarPermissao('ROLE_VALOR_FAIXA_CONSULTAR')"
          xl="4"
          md="6"
        >
          <b-card
            class="text-center cursor-pointer shadow-none border hover-shadow-lg transition-all"
            @click="$router.push({ name: 'mensalidades-matriz' })"
          >
            <div class="avatar avatar-xl bg-light-warning mb-2 mx-auto">
              <div class="avatar-content">
                <feather-icon
                  icon="TrendingUpIcon"
                  size="24"
                />
              </div>
            </div>
            <h5 class="font-weight-bolder">
              Matriz de Valores
            </h5>
            <p class="card-text">
              Configure os valores monetários associados a cada faixa e período.
            </p>
            <b-button
              variant="outline-warning"
              class="mt-1"
              block
              :to="{ name: 'mensalidades-matriz' }"
            >
              Acessar
            </b-button>
          </b-card>
        </b-col>

        <!-- Histórico de Geração -->
        <b-col
          v-if="verificarPermissao('ROLE_LOG_CONSULTAR')"
          xl="4"
          md="6"
        >
          <b-card
            class="text-center cursor-pointer shadow-none border hover-shadow-lg transition-all"
            @click="$router.push({ name: 'mensalidades-logs' })"
          >
            <div class="avatar avatar-xl bg-light-info mb-2 mx-auto">
              <div class="avatar-content">
                <feather-icon
                  icon="FileTextIcon"
                  size="24"
                />
              </div>
            </div>
            <h5 class="font-weight-bolder">
              Histórico de Geração
            </h5>
            <p class="card-text">
              Consulte os logs de processamento e resultados das gerações em lote.
            </p>
            <b-button
              variant="outline-info"
              class="mt-1"
              block
              :to="{ name: 'mensalidades-logs' }"
            >
              Acessar
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/permissionUtils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },
  methods: {
    verificarPermissao,
  },
}
</script>

<style lang="scss" scoped>
.hover-shadow-lg:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-5px);
}
.transition-all {
  transition: all 0.3s ease;
}
.avatar-xl {
  width: 60px;
  height: 60px;
}
</style>
